import { acceptHMRUpdate, defineStore } from 'pinia';
import type { LoadingStoreState } from '@/stores/schemas';

export type Sections = keyof LoadingStoreState;

export const useLoadingStore = defineStore('loading', {
	state: (): LoadingStoreState => ({
		patching: false,
		changing_person_choice: false,
		changing_main_product: false,
		changing_date: false,
		changing_product_filters: false,
		validating_step: false,
		validating_booking: false,
		login: false,
	}),

	actions: {
		loading(...sections: Sections[]) {
			sections.forEach((section) => {
				this[section] = true;
			});
			return sections;
		},

		unloading(...sections: Sections[]) {
			sections.forEach((section) => {
				this[section] = false;
			});
			return sections;
		},
	},
});

if (import.meta.hot) {
	import.meta.hot.accept(acceptHMRUpdate(useLoadingStore, import.meta.hot));
}
